import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { RESOURCE_TYPE, RESOURCE_DOMAIN } from "@plugins/common/constant/resource.constant.ts";
import { MEDIA_TYPE } from "@plugins/media/media.constant";

export function useResource(resourceData: { resourceDomain: string }) {
  const { t } = useI18n();

  const checkIfMoe = computed(() => resourceData.resourceDomain === RESOURCE_DOMAIN.MOE);

  const checkIfCommunity = computed(
    () => resourceData.resourceDomain === RESOURCE_DOMAIN.COMMUNITY,
  );

  const location = (loc: string): string => {
    switch (loc) {
      case "PERSONAL":
        return t("my_drive_label");
      case "MOE":
        return t("moe_library_label");
      case "COMMUNITY":
      case "Community":
        return t("community_gallery_label");
      case "ALP_TEMPLATE":
        return t("alp_template_label");
      case "APP":
        return t("app_library_label");
      case "ASSIGNMENT":
        return t("class_group_label");
      default:
        return "";
    }
  };

  const iconType = (resourceType: string, fileType: string | undefined, shared = false): string => {
    if (resourceType !== RESOURCE_TYPE.MEDIA) {
      switch (resourceType) {
        case RESOURCE_TYPE.FOLDER:
          return "Folder32";
        case RESOURCE_TYPE.LESSON:
          return shared ? "LessonStudentSharing32" : "Lesson32";
        case RESOURCE_TYPE.QUESTION:
          return "Question32";
        case RESOURCE_TYPE.QUIZ:
          return "Quiz32";
        case RESOURCE_TYPE.APP:
          return "App32";
        case RESOURCE_TYPE.RUBRIC:
          return "Rubrics32";
        default:
          return "";
      }
    }

    switch (fileType) {
      case MEDIA_TYPE.VIDEO:
        return "Video32";
      case MEDIA_TYPE.AUDIO:
        return "Audio32";
      case MEDIA_TYPE.IMAGE:
        return "Image32";
      case MEDIA_TYPE.PDF:
        return "PDF32";
      case MEDIA_TYPE.POWERPOINT:
        return "Powerpoint32";
      case MEDIA_TYPE.EXCEL:
        return "Excel32";
      case MEDIA_TYPE.WORD:
        return "Word32";
      case MEDIA_TYPE.HTML5:
        return "Interactive32";
      case MEDIA_TYPE.ZIP:
      case MEDIA_TYPE.OTHERS:
        return "Folder32";
      default:
        return "";
    }
  };

  const nodeTypeLabel = (resourceType) => {
    switch (resourceType) {
      case RESOURCE_TYPE.FOLDER:
        return t("resource_node_type_folder_label");
      case RESOURCE_TYPE.LESSON:
        return t("lesson_label");
      default:
        return "";
    }
  };
  return {
    checkIfMoe,
    checkIfCommunity,
    location,
    iconType,
    nodeTypeLabel,
  };
}
